export const routes = [
  {
    path: '/cidade/:id/pmd/:acompanhamento',
    component: () => import(/* webpackChunkName: "city" */ './components/Get'),
    name: 'city.pmd.get',
    meta: {
      requiresAuth: true
    }
  }
]
